/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import useGetCorrosionAlertsData from './hooks/useGetCorrosionAlertsData';
import { Download, InfoCircle, Search } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { Button, Card, Checkbox, Loading, Menu, MenuItem, Modal, Popover, Tag, TextInput, Tooltip } from '@sede-enterprise/shell-ds-react-framework';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { UnitContext } from '../../App';
import DataTable from '../../components/DataTable/DataTable';
import useDebounce from '../../util/useDebounce';
import { toast } from 'react-toastify';
import { alertStatusOptions } from '../../util/alertStatusOptions';
import CategoryLegend from './CategoryLegend';
import { DE_INSTALL_HELP, DE_INSTALLED_PROD_UNIT, helperTexts } from '../../util/helperTexts';
import { addCRComments, getCheckboxHeaderState, handleAllRowsSelection, handleCheckboxSelection, isRowSelected, resolveCRAlerts } from './util/alertsUtil';
import downloadCRAlerts from './util/downloadCRAlerts';
import { mmOrInch, mmOrMiles, splitToArray , downloadAsExcel} from '../../util/helperFunctions';
import { AuthContext } from '../../AuthProvider';



const sentimentMapping = {
    'GREEN': 'positive',
    'AMBER': 'warning',
    'RED': 'negative'
}

const crAlertCategoryHelperText = helperTexts.CrAlertsTable;

import * as R from "rambda";


const pageSize = 10;
const INIT_PAGE = 1;
const INIT_ORDER = "alertStartDate";
const INIT_ORDER_DIRECTION = 1
const sensor_filter = `sensor.excludeFromUi = 0`;

export const downloadAsXLSX = async (sensorData, columns) => {
    if (sensorData?.alertsList?.length && columns?.length > 0) {
        const downloadData = sensorData.alertsList.map((row) => {
            return columns.reduce((prev, curr) => {
                let value = '';
                if (typeof curr.accessorFn === 'function') {
                    value = curr.accessorFn(row);
                } else if (curr.id && row.hasOwnProperty(curr.id)) {
                    value = row[curr.id];
                }
                return {
                    ...prev,
                    [typeof curr.header === 'string' ? curr.header : curr.id]: value,
                };
            }, {});
        });

        await downloadAsExcel([{ sheetName: 'CorrosionList', data: downloadData }], 'CorrosionList.xlsx');
    }
};
const CorrosionAlertsTable = ({ filter }) => {

    const context = useContext(UnitContext);
    const authContext = useContext(AuthContext);
    const isTokenReady = authContext?.isTokenReady;

    const [currentPage, setCurrentPage] = useState(+sessionStorage.getItem("alertPage") || INIT_PAGE);
    const [sensorOrder, setSensorOrder] = useState(sessionStorage.getItem("alertOrder") || INIT_ORDER);
    const [orderDirection, setOrderDirection] = useState(+sessionStorage.getItem("alertorderDirection") || INIT_ORDER_DIRECTION);
    const orderString = orderDirection === 1 ? `DESC` : `ASC`;
    const [prevFilter, setPrevFilter] = useState(filter);
    const [selectedRows, setSelectedRows] = useState([]);
    const [refreshToggle, setRefreshToggle] = useState(false);

    const [userComment, setUserComment] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const handleModalClose = () => {
        setOpenModal(false)
        setUserComment("")
    }

    const [popupVisible, setPopupVisible] = useState(false);
    const handleOnPopupClick = () => {
        setPopupVisible(!popupVisible);
    };


    const [searchVal, setSearchVal] = useState("");
    const debouncedSearchVal = useDebounce(searchVal, 500);
    const [sensorListFilter, setSensorListFilter] = useState(sessionStorage.getItem("alertApplyfilter") || sensor_filter);

    useEffect(() => {
        if (prevFilter !== filter) {
            setCurrentPage(INIT_PAGE);
            sessionStorage.removeItem('alertPage');
        }
        setPrevFilter(filter);
    }, [filter]);

    useEffect(() => {
        if (debouncedSearchVal) {
            const filterValue = `${filter} AND (UPPER(sensor.name) LIKE UPPER('%${debouncedSearchVal}%') OR UPPER(sensor.conditionMonitoringLocation) LIKE UPPER('%${debouncedSearchVal}%')) AND ${sensor_filter}`;
            setSensorListFilter(filterValue);
            setCurrentPage(INIT_PAGE); // Reset the current page
            sessionStorage.removeItem('alertPage'); // Remove the current page from local storage
        } else {
            setSensorListFilter(filter);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearchVal, filter]);

    const handleOrderChange = (sortBy, direction) => {
        setSensorOrder(sortBy);
        sessionStorage.setItem('alertOrder', sortBy);

        setOrderDirection(+direction);
        sessionStorage.setItem('alertorderDirection', +direction);
    }

    const handleCurrentPageChange = (current) => {
        sessionStorage.setItem('alertPage', current)
        setCurrentPage(current);
    }

    const { data: corrosionAlertsData, loading } = useGetCorrosionAlertsData(sensorListFilter, pageSize, currentPage, sensorOrder,orderString, refreshToggle, isTokenReady);
    const { data: CorrosionDownLoadData, error: downloadError, loading: downloadLoading } = useGetCorrosionAlertsData(sensorListFilter, 10000, 1, sensorOrder, orderString, refreshToggle, isTokenReady);
    console.log("Corrosion Alerts Data:", CorrosionDownLoadData);
    console.log("cr data", corrosionAlertsData);
    console.log("length", corrosionAlertsData?.alertsList)
    /** @type import('@tanstack/react-table').ColumnDef<any> */
    
    const columns = [
        {

            id: 'rowSelection',
            header: () => {
                const { isChecked, isIndeterminate } = getCheckboxHeaderState(corrosionAlertsData, selectedRows);
                return <Checkbox indeterminate={isIndeterminate} checked={isChecked} onChange={(e) => handleAllRowsSelection(e, selectedRows, setSelectedRows, corrosionAlertsData)} />
            },
            cell: (props) => {
                const row = props.row.original;
                const isSelectedRow = isRowSelected(selectedRows, row);
                return <Checkbox checked={isSelectedRow} onChange={handleCheckboxSelection(row, selectedRows, setSelectedRows)} />
            }
        },
        {
            header: 'Start Date',
            accessorFn: (row) => row.alertStartDate,
            id: 'startDate'
        },
        {
            header: 'End Date',
            accessorFn: (row) => row.alertEndDate,
            id: 'endDate'
        },
        {
            header: 'Sensor',
            accessorFn: row => row.isRealSensor && row.name,
            id: 'sensor_id',
            cell: (props) => {
                const row = props.row.original;
                return <Link
                    className={
                        row.uninstalled
                            ? "link redContent"
                            : "link blueContent"
                    }
                    to={`/home/${encodeURIComponent(row.sensor_id)}/details`}
                    title={
                        row.uninstalled
                            ? R.path(
                                row.conditionMonitoringLocation
                            ) === DE_INSTALLED_PROD_UNIT
                                ? DE_INSTALL_HELP.bukam
                                : DE_INSTALL_HELP.other
                            : ""
                    }
                >
                    {row.isRealSensor && row.sensor_id}
                    {!row.isRealSensor && <span title="This CML has no sensor installed" className="redContent">No Sensor</span>}

                </Link>
            }
        },
        {
            header: 'CML',
            id: 'sensor.cmLocation.shortName',
            accessorFn: row => row.conditionMonitoringLocationName,
            cell: (props) => {
                const row = props.row.original;
                return row.conditionMonitoringLocationName ? (
                    <Link
                        className="link"
                        to={`/cmls/${encodeURIComponent(row.conditionMonitoringLocation)}/details`}
                    >

                        {row.conditionMonitoringLocationName}
                    </Link>
                ) : null
            },
        },
        {
            header: "Average CR (" + mmOrMiles(context.units) + ")",
            id: 'averageCRValue',
            cell: (props) => {
                const row = props.row.original;
                return context.units
                    ? (39.3700787402 * R.path(["averageCRValue"], row))?.toFixed(3)
                    : R.path(["averageCRValue"], row)?.toFixed(3)
            },
            accessorFn: (row) =>
                context.units
                    ? (39.3700787402 * R.path(["averageCRValue"], row))?.toFixed(3)
                    : R.path(["averageCRValue"], row)?.toFixed(3)
        },
        {
            header: 'Type',
            id: 'category',
            accessorFn: (row) => row.category
        },
        {
            header: <p>WL<sub>meas</sub>({mmOrInch(context.units)})</p>,
            id: 'measuredWallThicknessLoss',
            cell: (props) => {
                const row = props.row.original;
                return context.units
                    ? (
                        0.0393700787 *
                        R.pathOr(0, ["measuredWallThicknessLoss"], row)
                    ).toFixed(3)
                    : R.pathOr(0, ["measuredWallThicknessLoss"], row).toFixed(3)
            },
            accessorFn: (row) =>
                context.units
                    ? (
                        0.0393700787 *
                        R.pathOr(0, ["measuredWallThicknessLoss"], row)
                    ).toFixed(3)
                    : R.pathOr(0, ["measuredWallThicknessLoss"], row).toFixed(3),
        },
        {
            header: <p>WL<sub>pred</sub>({mmOrInch(context.units)})</p>,
            id: 'predictedWallThicknessLoss',
            cell: (props) => {
                const row = props.row.original;
                return context.units
                    ? (
                        0.0393700787 *
                        R.pathOr(0, ["predictedWallThicknessLoss"], row)
                    ).toFixed(3)
                    : R.pathOr(0, ["predictedWallThicknessLoss"], row).toFixed(3)
            },
            accessorFn: (row) =>
                context.units
                    ? (
                        0.0393700787 *
                        R.pathOr(0, ["predictedWallThicknessLoss"], row)
                    ).toFixed(3)
                    : R.pathOr(0, ["predictedWallThicknessLoss"], row).toFixed(3),
        },
        {
            header: "Alert Threshold (" + mmOrMiles(context.units) + ")",
            id: "sensor.alertThreshold",
            cell: (props) => {
                const row = props.row.original;
                return context.units
                    ? (39.3700787402 * R.path(["alertThreshold"], row)).toFixed(
                        3
                    )
                    : R.path(["alertThreshold"], row)
            },
            accessorFn: (row) =>
                context.units
                    ? (39.3700787402 * R.path(["alertThreshold"], row)).toFixed(
                        3
                    )
                    : R.path(["alertThreshold"], row),
        },
        {
            header: 'Category',
            id: 'colour',
            cell: (props) => {
                const row = props.row.original;
                return (
                    <Tag className='category-tip'
                        sentiment={sentimentMapping[row?.colour]}
                        variant='outlined'
                        size='small'
                        shape='round'
                    >
                        {row?.colour}
                    </Tag>
                )
            },
            accessorFn: (row) => row?.colour
        },
        {
            header: 'Status',
            id: 'status',
            accessorFn: (row) => R.path(["status"], row)
        },
        {
            header: 'Comments',
            id: 'comments',
            accessorFn: (row) => R.path(["comments"], row)
        }
    ]


    // Function to trigger data refresh
    const refreshData = () => {
        setSelectedRows([])
        setRefreshToggle(prev => !prev); // Flip the value to trigger useEffect
    };

    const addComments = () => {
        addCRComments(selectedRows, userComment, refreshData, handleModalClose, setUserComment);
    };

    const resolveAlerts = actionKey => {
        resolveCRAlerts(selectedRows, actionKey, refreshData);
    };


    const statusOverlay = (
        <Menu>
            {alertStatusOptions
                .filter(status => {
                    return status.resolve;
                })
                .map(status => (
                    <MenuItem key={status.value} onClick={(e) => resolveAlerts(e.key)}>{status.label}</MenuItem>
                ))}
        </Menu>
    )

    return (
        <div className='corrosion-alerts-section'>
            <div className='content-header'>

                <div className='header-title-help'>
                    <h2>Corrosion Rate Alerts</h2>
                    <Tooltip className='remanent-tooltip' placement='bottom'
                        overlay={<div className='tooltip-content'
                            id='remanent-id-100'>A Measured / Predicted Corrosion rate Alert is generated by considering the corrosion rate average of a set threshold. <br />  Start / End dates represent the period during which a Measured / Predicted Corrosion rate Alert is generated.
                            <CategoryLegend amberLabel={crAlertCategoryHelperText.amber} redLabel={crAlertCategoryHelperText.red} />
                        </div>}
                        trigger={<Button size='large' variant='transparent' iconOnly icon={<InfoCircle />} onClick={() => { }} />} />
                </div>




                <div className='header-actions'>


                    <Popover popup={statusOverlay}
                        onPopupClick={(e) => {
                            handleOnPopupClick()
                            e.stopPropagation()
                        }
                        }
                        popupVisible={popupVisible} arrow onPopupVisibleChange={setPopupVisible}
                    >
                        <Button onClick={() => { }}
                            disabled={selectedRows.length === 0}
                        >Resolve Alerts</Button>
                    </Popover>
                    <Button onClick={() => setOpenModal(true)}
                        disabled={selectedRows.length === 0}
                    >Add Comments</Button>

                    <div className='search-wrapper'>
                        <TextInput
                            // disabled={loading || (!loading && corrosionAlertsData?.alertsList?.length === 0)}
                            prefix={{ node: <Search className='search-icon' /> }}
                            placeholder='Search by Sensor or CML name'
                            onChange={(e) => {
                                setSearchVal(e.target.value);
                            }}
                            value={searchVal}
                        />
                    </div>
                    <Tooltip id='id-5' overlay={<span id='home-id-6'>Download</span>}
                            placement='bottom'
                            trigger={<Button iconOnly icon={<Download />} onClick={() => downloadAsXLSX(CorrosionDownLoadData, columns)} id='sensor-list-id-14' />} />

                </div>

            </div>
            <div className='content-body'>
                {corrosionAlertsData?.alertsList?.length <= 0 && loading && <div className='loading-container' role='status'><Loading /></div>}
                {!loading && corrosionAlertsData?.alertsList?.length === 0 && <Card className='empty-table-body' bodyPadding={false}>
                    <p className='data-value'>No Data under this Category</p>
                </Card>}

                {corrosionAlertsData?.alertsList?.length > 0 &&
                    <DataTable data={corrosionAlertsData.alertsList} columns={columns} count={corrosionAlertsData.alertsCount?.TotalRows}
                        currentPage={+sessionStorage.getItem("alertPage") || INIT_PAGE}
                        handleCurrentPageChange={handleCurrentPageChange}
                        handleOrderChange={handleOrderChange}
                        INIT_ORDER={sessionStorage.getItem("alertOrder") || INIT_ORDER}
                        INIT_ORDER_DIRECTION={+sessionStorage.getItem("alertorderDirection") || INIT_ORDER_DIRECTION}
                        loading={loading}
                    />}

            </div>
            <Modal open={openModal} onClose={handleModalClose} title="Add Comment"
                actions={[
                    {
                        label: 'Submit',
                        action: () => {
                            addComments()
                        },
                        props: {
                            disabled: userComment.length <= 0
                        }
                    },
                    {
                        label: 'Cancel',
                        action: () => {
                            handleModalClose();
                        },
                        props: {
                            variant: 'outlined'
                        }
                    }

                ]}
            >
                <TextInput placeholder='Add Your Comments'
                    value={userComment}
                    onChange={(e) => setUserComment(e.target.value)}
                />
            </Modal>
        </div>
    )
}

export default CorrosionAlertsTable